module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAACXBIWXMAAAsTAAALEwEAmpwYAAABFUlEQVQ4ja3SPS+DURgG4OsUMRiERGIRE5MYLAZhMondbKwmYhObRcxNaGORmBgsqMlvsPkHJgwSK/EYVLTq7QfvvZzknDtXTp5zUlSUUEafHJMgDqxKziRDucJ1fE7BNcb/rBXjc62mbxji0ISkhtn/oFBoPEsl994sCjf/QVtgSJtePFkRjn8FvpA2KJpH8TNRsY39pl4jlIF2hCEOrUlOMNiCZ6BdwRBVC8IlRpvwDLRrGKJsSr+aZLqbftcwRMUILrDYqdvyK9reYsOzR8vCacduL3BjomIPO1nGn+E6vo4jDOQK1/FlnGM4Vxiiasa7mmTya6+nx8tKKrrzah63ucKQtjzosyRckdMoGhO7CsaUPwCINEvBrzHcawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/live/selected.png
// module id = b75T
// module chunks = 11